export default "__VITE_ASSET__DbrwIr7a__"